import {AxiosInstance} from "axios";
import Site from "../model/site/Site";
import SiteData from "../model/site/SiteData";
import {SiteApiDto} from "./model/rest";
import {SitesMap} from "../store/reducer/site/SiteState";

/**
 * Api for sites.
 */
export default class SiteApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Creates site.
	 * @param {SiteData} data Site data transfer object.
	 * @returns {Promise<Site>} Promise containing created site.
	 */
	createSite(data: SiteData): Promise<Site> {
		const url = `/api/web/sites`;
		return this.axiosInstance.post(url, data.toJson()).then(resp => Site.fromJson(resp.data));
	}

	/**
	 * Fetch sites.
	 * @returns {Promise<SitesMap>} Promise containing all sites.
	 */
	fetchSites(): Promise<SitesMap> {
		const createMap = (sitesArray: SiteApiDto[]) =>
			sitesArray.reduce((obj: SitesMap, item) => {
				const site = Site.fromJson(item);
				obj[site.id] = site;
				return obj;
			}, {});
		const url = `/api/web/sites`;
		return this.axiosInstance.get(url).then(resp => createMap(resp.data));
	}

	/**
	 * Fetch site.
	 * @returns {Promise<Site>} Promise containing site.
	 */
	fetchSite(siteId: string): Promise<Site> {
		const url = `/api/web/sites/${siteId}`;
		return this.axiosInstance.get(url).then(resp => Site.fromJson(resp.data));
	}
}